"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>OtpForm_OtpForm
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_OtpForm_styles_js_namespaceObject = require("./OtpForm.styles.js");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const buildCountryDropdown_js_namespaceObject = require("./helpers/buildCountryDropdown.js");
const otpService_js_namespaceObject = require("../../utils/otpService.js");
var otpService_js_default = /*#__PURE__*/ __webpack_require__.n(otpService_js_namespaceObject);
const OtpContext_js_namespaceObject = require("../../context/OtpContext.js");
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const index_js_namespaceObject = require("../../constants/index.js");
const OtpForm = ()=>{
    const choiceChipOptions = [
        {
            label: 'Send to Phone',
            icon: external_pcln_icons_namespaceObject.Smartphone,
            deliveryType: index_js_namespaceObject.otpDeliveryMechanisms.SMS
        },
        {
            label: 'Send to Email',
            icon: external_pcln_icons_namespaceObject.Email,
            deliveryType: index_js_namespaceObject.otpDeliveryMechanisms.EMAIL
        }
    ];
    const errorMessage = "I\u2019m\xa0having\xa0some trouble\xa0accessing your trip information. ";
    const [phoneColor, setPhoneColor] = (0, external_react_namespaceObject.useState)();
    const [emailColor, setEmailColor] = (0, external_react_namespaceObject.useState)();
    const [phoneNumber, setPhoneNumber] = (0, external_react_namespaceObject.useState)();
    const [email, setEmail] = (0, external_react_namespaceObject.useState)();
    const [countryCode, setCountryCode] = (0, external_react_namespaceObject.useState)('1');
    const [otpFormSubmissionInProgress, setOtpFormSubmissionInProgress] = (0, external_react_namespaceObject.useState)(false);
    const [deliveryType, setDeliveryType] = (0, external_react_namespaceObject.useState)(index_js_namespaceObject.otpDeliveryMechanisms.SMS_PHONE);
    const [showEmailInput, setShowEmailInput] = (0, external_react_namespaceObject.useState)(false);
    const [showSmsInput, setShowSmsInput] = (0, external_react_namespaceObject.useState)(true);
    const [showEmailOrSmsToggle, setShowEmailOrSmsToggle] = (0, external_react_namespaceObject.useState)(false);
    const [choiceChipSelected, setChoiceChipSelected] = (0, external_react_namespaceObject.useState)();
    const { setOtpRequestErrorMsg, setOtpDeliveryType, setVerificationApiFunction, setShowOtpVerificationForm, setOtpFormData, otpFormData } = (0, OtpContext_js_namespaceObject.useOtpContext)();
    const { setAccountLessTripsAccessPayload, submitChatMessagesPayload, requestFrom } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { cguid, resolvedClientIP } = submitChatMessagesPayload || {};
    (0, external_react_namespaceObject.useEffect)(()=>{
        setOtpDeliveryType(deliveryType);
    }, [
        deliveryType,
        setOtpDeliveryType
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if ('1' === countryCode) {
            setShowSmsInput(true);
            setShowEmailInput(false);
            setShowEmailOrSmsToggle(false);
            setDeliveryType(index_js_namespaceObject.otpDeliveryMechanisms.SMS_PHONE);
            setEmail(void 0);
            setOtpFormData({
                ...otpFormData,
                email: void 0
            });
        } else {
            setShowSmsInput(true);
            setShowEmailInput(true);
        }
    }, [
        countryCode
    ]);
    const isPhoneValidated = (0, external_react_namespaceObject.useMemo)(()=>{
        if (!phoneNumber) return false;
        const isValidFormat = /^[0-9]+$/.test(phoneNumber) || /^\d{3}-\d{3}-\d{4}$/.test(phoneNumber);
        if (!isValidFormat) return false;
        const digits = phoneNumber.replace(/-/g, '');
        if ('1' === countryCode) return 10 === digits.length;
        return digits.length >= 5;
    }, [
        phoneNumber,
        countryCode
    ]);
    const getChoiceChipLabel = (option)=>{
        if (option.deliveryType === index_js_namespaceObject.otpDeliveryMechanisms.SMS || option.deliveryType === index_js_namespaceObject.otpDeliveryMechanisms.SMS_PHONE) {
            if (phoneNumber && phoneNumber.length >= 2) {
                const lastTwoDigits = phoneNumber.slice(-2);
                return `${option.label} (+${countryCode} ........${lastTwoDigits})`;
            }
        } else {
            const [localPart, domain] = email?.split('@');
            const firstLetter = localPart?.charAt(0);
            return `${option.label} (${firstLetter}...@${domain})`;
        }
        return option.label;
    };
    const isEmailValidated = (0, external_react_namespaceObject.useMemo)(()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email), [
        email
    ]);
    const disableButton = (0, external_react_namespaceObject.useMemo)(()=>{
        if ('1' === countryCode) return !isPhoneValidated;
        return !isPhoneValidated || !isEmailValidated;
    }, [
        isEmailValidated,
        isPhoneValidated,
        countryCode
    ]);
    function checkPhoneValidation() {
        if (phoneNumber) setPhoneColor(isPhoneValidated ? 'success' : 'error');
    }
    function checkEmailValidation() {
        if (email) setEmailColor(isEmailValidated ? 'success' : 'error');
    }
    function handlePhoneChange(e) {
        const value = e.currentTarget.value;
        if (/^\d*$/.test(value)) setPhoneNumber(value);
    }
    function handleEmailChange(e) {
        const value = e.currentTarget.value;
        setEmail(value);
    }
    async function handleContinueClick(e) {
        if ('1' === countryCode) await submitFormHandler(e, deliveryType);
        else setShowEmailOrSmsToggle(true);
    }
    async function submitFormHandler(e, deliveryType) {
        e.preventDefault();
        setOtpRequestErrorMsg('');
        setOtpFormData({
            ...phoneNumber && {
                phoneNumber: Number(phoneNumber)
            },
            ...countryCode && {
                countryCode: countryCode
            },
            ...email && {
                email: email
            }
        });
        setAccountLessTripsAccessPayload(deliveryType === index_js_namespaceObject.otpDeliveryMechanisms.SMS_PHONE ? {
            phoneNumber: {
                number: phoneNumber,
                countryCode
            },
            scope: 'TRIPS'
        } : {
            emailAddress: email,
            phoneNumber: {
                number: phoneNumber,
                countryCode
            },
            scope: 'TRIPS'
        });
        setOtpFormSubmissionInProgress(true);
        setOtpRequestErrorMsg('');
        try {
            const otpServiceInstance = otpService_js_default()({
                deliveryType
            });
            if (otpServiceInstance.verify) setVerificationApiFunction(()=>otpServiceInstance.verify);
            const otpChallenge = await otpServiceInstance.createChallenge({
                phoneNumber,
                email,
                countryCode,
                scope: 'trips',
                requestHeaders: {
                    'x-pcln-client-ip': resolvedClientIP,
                    cguid
                },
                requestFrom
            });
            if (otpChallenge) setShowOtpVerificationForm(true);
            else setOtpRequestErrorMsg(errorMessage);
        } catch (_e) {
            setOtpRequestErrorMsg(errorMessage);
        } finally{
            setOtpFormSubmissionInProgress(false);
        }
    }
    async function handleChoiceChipClick(e, option) {
        setDeliveryType(option.deliveryType);
        setChoiceChipSelected(option.label);
        await submitFormHandler(e, option.deliveryType);
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                maxWidth: "390px",
                children: otpFormSubmissionInProgress ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Spinner, {}) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                            flexDirection: 'column',
                            mb: 2,
                            children: [
                                showSmsInput && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                            width: '30%',
                                            mr: 2,
                                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Relative, {
                                                children: [
                                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.FormField, {
                                                        children: [
                                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Label, {
                                                                htmlFor: "countryCodes",
                                                                children: 'Country Code \u207A'
                                                            }),
                                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.SelectInput, {
                                                                defaultValue: "1",
                                                                id: "countryCodes",
                                                                name: "countryCodes",
                                                                value: countryCode,
                                                                onChange: function(e) {
                                                                    setCountryCode(e.target.value);
                                                                },
                                                                children: buildCountryDropdown_js_namespaceObject.uniqCountryCodes.map((country)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("option", {
                                                                        value: country.phoneCode,
                                                                        children: country.label
                                                                    }, country.label))
                                                            }),
                                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.SuccessIcon, {
                                                                color: "success"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Absolute, {
                                                        bg: "background.lightest",
                                                        top: 17,
                                                        left: 14,
                                                        width: "75px",
                                                        style: {
                                                            pointerEvents: 'none'
                                                        },
                                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                                                                fontSize: 1,
                                                                children: [
                                                                    "+",
                                                                    countryCode
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                                            width: '70%',
                                            children: [
                                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.FormField, {
                                                    children: [
                                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Label, {
                                                            htmlFor: "phone",
                                                            children: 'Phone Number \u207A'
                                                        }),
                                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.FormInput, {
                                                            id: "phone",
                                                            name: "phone",
                                                            type: "text",
                                                            inputMode: "numeric",
                                                            pattern: "[0-9]*",
                                                            placeholder: 'Phone number \u207A',
                                                            onChange: handlePhoneChange,
                                                            onFocus: function() {
                                                                setPhoneColor(void 0);
                                                            },
                                                            onBlur: checkPhoneValidation,
                                                            color: phoneColor,
                                                            value: phoneNumber,
                                                            "aria-describedby": "phone-error"
                                                        }),
                                                        'error' === phoneColor ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.WarningIcon, {
                                                            color: "error"
                                                        }) : null,
                                                        'success' === phoneColor ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.SuccessIcon, {
                                                            color: "success"
                                                        }) : null
                                                    ]
                                                }),
                                                'error' === phoneColor ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.ErrorToolTip, {
                                                    id: "phone-error",
                                                    right: true,
                                                    color: "error",
                                                    children: "Phone number is invalid"
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                showEmailInput && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                                    my: 2,
                                    children: [
                                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.FormField, {
                                            children: [
                                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Label, {
                                                    htmlFor: "email",
                                                    children: 'Email Address \u207A'
                                                }),
                                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.FormInput, {
                                                    id: "email",
                                                    name: "email",
                                                    placeholder: 'Email address \u207A',
                                                    onChange: handleEmailChange,
                                                    onFocus: function() {
                                                        setEmailColor(void 0);
                                                    },
                                                    onBlur: checkEmailValidation,
                                                    color: emailColor,
                                                    value: email
                                                }),
                                                'error' === emailColor ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.WarningIcon, {
                                                    color: "error"
                                                }) : null,
                                                'success' === emailColor ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_OtpForm_styles_js_namespaceObject.SuccessIcon, {
                                                    color: "success"
                                                }) : null
                                            ]
                                        }),
                                        'error' === emailColor ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Tooltip, {
                                            id: "email-error",
                                            right: true,
                                            color: "error",
                                            children: "Email is invalid"
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        !showEmailOrSmsToggle && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                            mt: 1,
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                                disabled: disableButton,
                                onClick: handleContinueClick,
                                children: "Continue"
                            })
                        })
                    ]
                })
            }),
            showEmailOrSmsToggle && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                        mb: 3,
                        children: "Choose how you'd like to verify. We'll send a 6-digit code to one of your provided contacts."
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        children: choiceChipOptions.map((option)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                                flexDirection: "row",
                                mb: 2,
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChoiceChip, {
                                    label: getChoiceChipLabel(option),
                                    Icon: option.icon,
                                    selected: choiceChipSelected === option.label,
                                    onClick: async function(e) {
                                        await handleChoiceChipClick(e, option);
                                    }
                                })
                            }, option.label))
                    })
                ]
            })
        ]
    });
};
const OtpForm_OtpForm = OtpForm;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
